module.exports = __webpack_public_path__ + "img/empreendimento-logo-20.f68f8fc1.png";